import styled from '@emotion/styled';
import { mediaQueries } from 'styles/variables';

export const ButtonWrapper = styled.div`
    text-align: right;
    width: 100%;
    button {
        width: 100%;
        margin-top: 0.4rem;
        margin-bottom: 1.2rem;
    }
    ${mediaQueries.mediumUp} {
        button {
            width: auto;
        }
    }
`;

export const HeadingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    ${mediaQueries.mediumUp} {
        flex-direction: row;
    }

    .heading-texture {
        max-width: 51rem;
        ${mediaQueries.mediumUp} {
            align-self: flex-end;
        }
    }

    img {
        ${mediaQueries.mediumUp} {
            width: 31.3rem;
            height: 15.3rem;
        }
    }
`;

export const NotificationWrapper = styled.div`
    .alert {
        margin-top: 2rem;
    }
`;
